/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
.m-list--unstyled,
.m-list--horizontal,
.m-list--links {
  padding-left: 0;
  list-style-type: none;
}
.m-list--unstyled .m-list__item,
.m-list--horizontal .m-list__item,
.m-list--links .m-list__item {
  margin-left: 0;
}

.m-list--spaced .m-list--spaced,
.m-list--spaced .m-list__item + .m-list__item {
  margin-top: 1.5em;
}

.m-list--horizontal .m-list__item {
  display: inline-block;
  margin-right: 0.25em;
  margin-bottom: 0;
}

@media only all and (max-width: 37.5em) {
  .m-list--links .m-list__item {
    margin-bottom: 0;
  }
}

html[lang=ar] .m-list {
  padding-right: 0;
}